import { useEffect, useRef, useState } from "react";
import "./LeadershipPage.css";

import PrasadProfile from "../../../assets/PrasadProfile.jpg";
import SatishProfile from "../../../assets/SatishProfile.png";
import founder from "../../../assets/founder.png";
import isb_logo from "../../../assets/isb_logo.svg"

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const PinIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

const leaders = [
  {
    id: "ramesh",
    name: "Ramesh Babu Bairy",
    position: "Founder & Principal Advisor",
    title: "Founder & Principal Advisor – AI, Digital Transformation & Future-Ready Enterprises",
    subtitle: "Certified Chief Digital & AI Officer",
    img: isb_logo,
    location: "Global",
    photo: founder,
    initials: "RB",
    linkedin: "https://www.linkedin.com/in/ramesh-babu-bairy-8a34953",
    tags: ["AI Strategy", "Enterprise Transformation", "Healthcare Innovation", "Global Leadership"],
    bio: [
      "Ramesh Babu Bairy is a global AI and digital transformation strategist with over two decades of experience helping enterprises reimagine business models, modernise operations, and build future-ready organizations through technology-led transformation.",
      "He has led large-scale transformation initiatives across the US, Europe, GCC, India, and APAC, including a €650 million enterprise-wide transformation program for a German organisation and strategic operational initiatives delivering measurable efficiency improvements for global manufacturing enterprises.",
      "Ramesh is particularly known for translating emerging technologies — especially artificial intelligence — into practical, scalable, and human-centered business outcomes. His work focuses on bridging the gap between AI ambition and enterprise execution, enabling organizations to adopt innovation responsibly while driving sustainable growth, operational resilience, and long-term value creation.",
      "He is deeply passionate about the intersection of AI, preventive healthcare, wellness, and societal impact, with a strong belief that the next wave of digital transformation will fundamentally reshape how individuals, enterprises, and communities experience health, productivity, and well-being.",
      "Through BaiRees Global Advisory, Ramesh advises organizations on AI strategy, enterprise transformation, and building resilient, innovation-led digital ecosystems for the future.",
    ],
  },
  {
    id: "satish",
    name: "Satish Bairy",
    position: "Strategic Advisor",
    title: "Strategic Advisor – AI, Digital Transformation & Enterprise Technology",
    subtitle: "Asian Institute of Management Philippines Alumni",
    location: "Melbourne, Australia",
    photo: SatishProfile,
    initials: "SB",
    linkedin: "https://www.linkedin.com/in/satishbairy/",
    tags: ["AI Strategy", "Digital Transformation", "Enterprise Technology", "Governance"],
    bio: [
      "Satish Bairy is a senior business and technology leader based in Melbourne with over two decades of experience leading enterprise-scale digital transformation, AI strategy, and technology modernisation initiatives across Australia and the Asia-Pacific region.",
      "He is the Founder & Managing Director of Appsmart, where he advises enterprises on AI adoption, digital operating models, customer transformation, governance, and technology-led growth.",
      "Prior to this, Satish held senior leadership roles with DXC Technology, HCL Technologies, LTIMindtree, and Tata Consultancy Services, leading strategic transformation programs and enterprise engagements across retail, consumer, and manufacturing sectors.",
      "Satish also served as a Portfolio Governance Committee Member with Wyndham City Council, contributing strategic oversight across transformation and governance initiatives.",
      "At BaiRees Global Advisory, Satish brings a distinctive blend of enterprise leadership, governance expertise, and pragmatic AI transformation experience, helping organisations build future-ready, innovation-led businesses.",
    ],
  },
  {
    id: "prasad",
    name: "Prasad Gollapalli",
    position: "Strategic Advisor",
    title: "Strategic Advisor, Digital Transformation & Product Leadership",
    subtitle: "Ex-Cisco · Ex-Dell · IIMJ Alumni",
    location: "India",
    photo: PrasadProfile,
    initials: "PG",
    linkedin: "https://www.linkedin.com/in/prasad-gollapalli-5b6bb63?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    tags: ["Product Strategy", "Digital Transformation", "Agentic AI", "Program Governance"],
    bio: [
      "Prasad Gollapalli is a seasoned strategic advisor with over 25 years of experience guiding organizations through complex transformation, product evolution, and large-scale technology initiatives. He partners with boards, founders, and executive leadership teams to translate business vision into executable strategies that drive sustainable growth and operational excellence.",
      "Prasad brings deep expertise in enterprise product strategy, digital transformation, and program governance, having led multi-million-dollar portfolios and global teams across diverse industries. His experience spans cloud transformation, platform modernization, fintech enablement, and post-merger technology integration, with a strong focus on aligning technology investments to business outcomes.",
      "He has a proven track record of building and scaling product portfolios, establishing KPI-driven governance models, and enabling organizations to deliver predictable, high-impact results. His leadership has consistently driven improvements in customer experience, delivery efficiency, and time-to-market.",
      "He is also actively engaged in advising on emerging areas such as AI-led transformation and agentic AI, helping organizations leverage next-generation technologies to create competitive advantage.",
      "Prasad is known for his ability to navigate complexity, build consensus across stakeholders, and provide clear, actionable guidance at the intersection of business and technology.",
    ],
  },
];

export default function LeadershipPage() {
  const [activeId, setActiveId] = useState(leaders[0].id);
  const [scrolled, setScrolled] = useState(false);
  const sectionRefs = useRef({});
  const isScrollingTo = useRef(false);
  const navRef = useRef(null);

  // Sticky nav shadow on scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Intersection observer for active highlight
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (isScrollingTo.current) return;
        entries.forEach((e) => {
          if (e.isIntersecting) setActiveId(e.target.dataset.id);
        });
      },
      { rootMargin: "-20% 0px -65% 0px" }
    );
    Object.values(sectionRefs.current).forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    isScrollingTo.current = true;
    setActiveId(id);
    const el = sectionRefs.current[id];
    if (el) {
      const navH = navRef.current ? navRef.current.offsetHeight : 0;
      const top = el.getBoundingClientRect().top + window.scrollY - navH - 32;
      window.scrollTo({ top, behavior: "smooth" });
      setTimeout(() => { isScrollingTo.current = false; }, 900);
    }
  };

  return (
    <div className="lp-page">

      {/* ── Sticky nav ────────────────────────────────── */}
      <nav
        ref={navRef}
        className={`lp-nav${scrolled ? " lp-nav--scrolled" : ""}`}
        aria-label="Leadership navigation"
      >
        <div className="lp-nav__inner">
          <span className="lp-nav__label">Leadership</span>
          <div className="lp-nav__pills">
            {leaders.map((l) => (
              <button
                key={l.id}
                className={`lp-pill${activeId === l.id ? " lp-pill--active" : ""}`}
                onClick={() => scrollTo(l.id)}
                aria-current={activeId === l.id ? "true" : undefined}
              >
                <div className="lp-pill__avatar">
                  {l.photo
                    ? <img src={l.photo} alt={l.name} />
                    : <span>{l.initials}</span>}
                </div>
                <div className="lp-pill__text">
                  <span className="lp-pill__name">{l.name.split(" ")[0]}</span>
                  <span className="lp-pill__role">{l.position}</span>
                </div>
                {activeId === l.id && <span className="lp-pill__dot" aria-hidden="true" />}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* ── Profiles ─────────────────────────────────── */}
      <div className="lp-profiles">
        {leaders.map((leader, idx) => (
          <section
            key={leader.id}
            id={leader.id}
            data-id={leader.id}
            ref={(el) => (sectionRefs.current[leader.id] = el)}
            className="lp-profile"
          >
            <div className="lp-profile__inner">

              {/* Left card */}
              <aside className="lp-card">
                <div className="lp-avatar">
                  {leader.photo
                    ? <img src={leader.photo} alt={leader.name} className="lp-avatar__img" />
                    : <span className="lp-avatar__initials">{leader.initials}</span>}
                  <div className="lp-avatar__ring" aria-hidden="true" />
                </div>

                <h2 className="lp-card__name">{leader.name}</h2>
                <p className="lp-card__role">{leader.position}</p>
                {leader.subtitle && (
                  <p className="lp-card__subtitle">{leader.subtitle}  <img src={leader.img} className="isb-logo" alt="" /></p>
                  
                )}

                <p className="lp-card__location">
                  <PinIcon /> {leader.location}
                </p>

                {leader.linkedin && (
                  <a
                    href={leader.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lp-card__linkedin"
                    aria-label={`${leader.name} on LinkedIn`}
                  >
                    <LinkedInIcon />
                    <span>LinkedIn Profile</span>
                  </a>
                )}

                <div className="lp-card__tags">
                  {leader.tags.map((t) => (
                    <span key={t} className="lp-tag">{t}</span>
                  ))}
                </div>
              </aside>

              {/* Right bio */}
              <div className="lp-bio">
                <div className="lp-bio__eyebrow" aria-hidden="true">
                  <span className="lp-bio__line" />
                  <span className="lp-bio__pos">{leader.title}</span>
                </div>
                {leader.bio.map((para, i) => (
                  <p key={i} className="lp-bio__para">{para}</p>
                ))}
              </div>

            </div>

            {idx < leaders.length - 1 && (
              <div className="lp-divider" aria-hidden="true" />
            )}
          </section>
        ))}
      </div>
    </div>
  );
}